import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Text } from "@fluentui/react-components";
import { useAuth } from "../auth/AuthContext";
import { useMyProfileStyles } from "./MyProfile.styles";
import Header from "../components/Header";
import Loading from "../components/Loading";

const MyProfile = () => {
  const { isAuthenticated, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const styles = useMyProfileStyles();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, authLoading, navigate]);

  if (authLoading) {
    return <Loading message="Loading profile..." />;
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Header />
      <Card className={styles.card}>
        <Text as="h3" className={styles.cardTitle}>
          👤 User Information
        </Text>
        <div className={styles.userInfo}>
          <div className={styles.userInfoItem}>
            <Text className={styles.userInfoLabel}>Name:</Text>
            <Text>{user.name || "N/A"}</Text>
          </div>
          <div className={styles.userInfoItem}>
            <Text className={styles.userInfoLabel}>Email:</Text>
            <Text>{user.email || "N/A"}</Text>
          </div>
          <div className={styles.userInfoItem}>
            <Text className={styles.userInfoLabel}>Logged in at:</Text>
            <Text>{new Date().toLocaleTimeString()}</Text>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MyProfile;
